import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '../../components/ui/dialog';
import { Check } from 'lucide-react';
import { fmt } from './constants';

const CreateLotDialog = ({
  open, onOpenChange,
  lotForm, setLotForm,
  inStockForLot,
  selectedPieceIds, togglePiece,
  onSubmit,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg max-h-[92vh] overflow-hidden flex flex-col">
      <DialogHeader>
        <DialogTitle>Create Lot</DialogTitle>
        <DialogDescription>Selected pieces go into the shared pool — any on-duty MIA can pick them up for breakage.</DialogDescription>
      </DialogHeader>
      <div className="space-y-3 overflow-y-auto pr-1 flex-1">
        <div>
          <Label>Remarks (optional)</Label>
          <Input value={lotForm.remarks}
            onChange={(e) => setLotForm({ ...lotForm, remarks: e.target.value })}
            data-testid="lot-remarks-input" className="h-11" />
        </div>
        <div>
          <Label>Pick In-Stock Pieces ({selectedPieceIds.length} selected)</Label>
          <div className="border rounded-lg max-h-72 overflow-auto divide-y" data-testid="lot-picker-body">
            {inStockForLot.length === 0 && (
              <div className="text-center py-4 text-slate-400 text-sm">No in-stock pieces</div>
            )}
            {inStockForLot.map((p) => (
              <label key={p._id} className="p-3 flex items-center gap-3 hover:bg-amber-50 cursor-pointer">
                <input
                  type="checkbox"
                  className="w-5 h-5"
                  checked={selectedPieceIds.includes(p.serial_no)}
                  onChange={() => togglePiece(p.serial_no)}
                  data-testid={`lot-pick-${p.serial_no}`}
                />
                <div className="flex-1 min-w-0">
                  <div className="font-mono text-xs">{p.serial_no}</div>
                  <div className="text-xs text-slate-500">
                    {p.branch} · {fmt(p.gross_weight)} gm · {fmt(p.expected_purity, 2)}%
                  </div>
                </div>
              </label>
            ))}
          </div>
        </div>
      </div>
      <div className="pt-3 border-t flex gap-2">
        <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1 h-11">Cancel</Button>
        <Button onClick={onSubmit} className="flex-1 h-11 bg-amber-700 hover:bg-amber-800" data-testid="lot-submit-btn">
          <Check className="w-4 h-4 mr-2" /> Create
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default CreateLotDialog;
